import React from 'react';
import {CustomButton, Popup} from "..";
import {useState} from "react";

export function Discard(props) {
    const [visible, setVisible] = useState(false)

    // const [confirm, setConfirm] = useState(false)


    function _show(e) {
        setVisible(true)
    }

    function _hide() {
        setVisible(false)
    }

    function _confirmDone() {
        setVisible(false)
        props.onClick();
    }

    return (
        <>
            <CustomButton
                label="Discard Changes"
                icon="bi bi-x-circle-fill"
                onClick={_show}
                type='button'
                style={props.style}
                className="p-button-warning btc"
                iconPos="right"
            />

            <Popup
                header="Discard Changes?"
                visible={visible}
                onHide={_hide}>
                <div>
                    <div className='confirmation-content'>
                        <i className='pi pi-question-circle p-mr-3' style={{fontSize: '2rem', margin: '0.5rem'}}/>
                        <span>Are you sure you want to discard changes on this page?</span>
                    </div>
                    <div className="p-col-12 p-fluid">
                        <div className="p-grid  p-justify-end">
                            <div className=" p-col-3">
                                <CustomButton
                                    label='Discard'
                                    //icon='pi pi-times'
                                    type="button"
                                    id='no-btn'
                                    onClick={_hide}
                                    className="p-button-warning btc"
                                />
                            </div>
                            <div className=" p-col-3">
                                <CustomButton
                                    label='Continue'
                                    //icon='pi pi-check'
                                    type="button"
                                    id='yes-btn'
                                    onClick={_confirmDone}
                                    className='p-button-text'
                                    autoFocus
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        </>
    );
}